var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 3.33333C5.83333 3.79357 6.20643 4.16667 6.66667 4.16667C7.1269 4.16667 7.5 3.79357 7.5 3.33333C7.5 2.8731 7.1269 2.5 6.66667 2.5C6.20643 2.5 5.83333 2.8731 5.83333 3.33333Z",
    stroke: "#B9B9B9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.33333C12.5 3.79357 12.8731 4.16667 13.3334 4.16667C13.7936 4.16667 14.1667 3.79357 14.1667 3.33333C14.1667 2.8731 13.7936 2.5 13.3334 2.5C12.8731 2.5 12.5 2.8731 12.5 3.33333Z",
    stroke: "#B9B9B9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 10C5.83333 10.4603 6.20643 10.8334 6.66667 10.8334C7.1269 10.8334 7.5 10.4603 7.5 10C7.5 9.53978 7.1269 9.16669 6.66667 9.16669C6.20643 9.16669 5.83333 9.53978 5.83333 10Z",
    stroke: "#B9B9B9",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C12.5 10.4603 12.8731 10.8334 13.3334 10.8334C13.7936 10.8334 14.1667 10.4603 14.1667 10C14.1667 9.53978 13.7936 9.16669 13.3334 9.16669C12.8731 9.16669 12.5 9.53978 12.5 10Z",
    stroke: "#B9B9B9",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 16.6666C5.83333 17.1269 6.20643 17.5 6.66667 17.5C7.1269 17.5 7.5 17.1269 7.5 16.6666C7.5 16.2064 7.1269 15.8333 6.66667 15.8333C6.20643 15.8333 5.83333 16.2064 5.83333 16.6666Z",
    stroke: "#B9B9B9",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.6666C12.5 17.1269 12.8731 17.5 13.3334 17.5C13.7936 17.5 14.1667 17.1269 14.1667 16.6666C14.1667 16.2064 13.7936 15.8333 13.3334 15.8333C12.8731 15.8333 12.5 16.2064 12.5 16.6666Z",
    stroke: "#B9B9B9",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.b13e773c.svg";
export { ForwardRef as ReactComponent };